import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { FilenameObjectType } from "@src/types/ota-update";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export const isFilenameUsable = async (
  namespace: string,
  filename: string,
  objectType: FilenameObjectType,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<boolean>(
      `${url}/api/v1/ns/${namespace}/filename-usable`,
      {
        headers,
        params: {
          filename,
          object_type: objectType,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to validate filename.",
      );
    }

    throw new Error("An unexpected error occurred while validating filename.");
  }
};
